<app-breadcrumb [crumbPaths]="[{
        name: 'Home',
        path: '/home'
    }, {
        name: 'Survey',
        path: '/survey'
    }, {
        name: 'Survey details',
        path: '/survey',
        active: true
    }]">
</app-breadcrumb>
<div class="row">
    <div class="col-4">
        <app-page-header title="Forms" [buttons]="[{
            name: 'Add Group',
            eventName: 'add-group',
            cssClass: 'bg-secondary'
        }, {
            name: 'Add',
            eventName: 'add',
            cssClass: 'bg-primary'
        }, {
            name: 'Delete',
            eventName: 'delete-survey',
            cssClass: 'bg-danger'
        }]" (onButtonClick)="gridActions($event)">
        </app-page-header>
        <app-page-content>
            <app-data-grid [dataSource]="formAndGroupList" [config]="tableConfig" (dataActionEvent)="gridActions($event)">
            </app-data-grid>
        </app-page-content>

        <ng-container *ngFor="let group of groupList">
            <app-page-header [title]="group.name" [buttons]="[{
                name: 'Delete',
                eventName: 'edit-formGroup',
                icon: 'fa fa-pencil'
            }, {
                name: 'Delete',
                eventName: 'delete-formGroup',
                cssClass: 'bg-danger'
            }, {
                name: 'Add',
                eventName: 'add',
                cssClass: 'bg-primary'
            }]" (onButtonClick)="gridActions($event, group)">
            </app-page-header>
            <app-page-content>
                <app-data-grid [dataSource]="groupForms[group._id]" [config]="tableConfig"
                    (dataActionEvent)="gridActions($event)">
                </app-data-grid>
            </app-page-content>
        </ng-container>
    </div>
    <div class="col-8">
        <app-page-content>
            <div *ngIf="selectedForm != null">
                <iframe [srcdoc]="selectedForm.content | safeHtml" class="w-100" style="min-height: 80vh;"></iframe>
            </div>
        </app-page-content>
    </div>
</div>

<dx-popup [width]="300" [height]="200" [showTitle]="true" title="Add New Group" [dragEnabled]="false"
    [hideOnOutsideClick]="true" [showCloseButton]="false" [(visible)]="isAddNewGroupPopup">
    <div *dxTemplate="let data of 'content'">
        <div class="mb-2">
            Name
            <dx-text-box [(value)]="newGroup.name"></dx-text-box>
        </div>
        <!-- <div class="mb-2">
            Type
            <dx-select-box [(value)]="newGroup.type" [items]="['standard', 'recursive']"></dx-select-box>
        </div> -->
        <dx-button (onClick)="onSaveNewGroup()" class="w-100 bg-success">Add</dx-button>
    </div>
</dx-popup>

<dx-popup [width]="300" [height]="200" [showTitle]="true" title="Edit Group" [dragEnabled]="false"
    [hideOnOutsideClick]="true" [showCloseButton]="false" [(visible)]="editGroupPopup.visible">
    <div *dxTemplate="let data of 'content'">
        <div class="mb-2">
            Name
            <dx-text-box [(value)]="editGroupPopup.newName"></dx-text-box>
        </div>
        <dx-button (onClick)="onSaveFormGroupRename()" class="w-100 bg-success">Save</dx-button>
    </div>
</dx-popup>

<app-alert [(visible)]="alertFormDelete.visible" [buttons]="[{
            name: 'Calcel',
            eventName: 'cancel',
            cssClass: 'bg-secondary'
        }, {
            name: 'Yes, Proceed',
            eventName: 'okay',
            cssClass: 'bg-danger'
        }]" (successHandler)="deleteForm(alertFormDelete.form)">
    Are you Sure?
</app-alert>

<app-alert [(visible)]="alertSurveyDelete.visible" [buttons]="[{
    name: 'Calcel',
    eventName: 'cancel',
    cssClass: 'bg-secondary'
}, {
    name: 'Yes, Proceed',
    eventName: 'okay',
    cssClass: 'bg-danger'
}]" (successHandler)="deleteSurvey()">
    Are you Sure?
</app-alert>